import { useMemo, type FC } from 'react';

import { SectionContainer } from '../../../../components/section-container/section-container';
import { SimpleCompanyCardGrid } from '../../../../components/simple-company-card-grid/simple-company-card-grid';
import { useMostVisitedCompanies } from '../../../../hooks/use-most-visited-companies';
import { createSimpleCompanies } from '../../../../models/simple-company';
import { ROUTES } from '../../../../routes';

const LIMIT = 6;

export const MostVisitedCompaniesSection: FC = () => {
  const { data, loading } = useMostVisitedCompanies({
    limit: LIMIT,
  });

  const mostVisitedCompanies = data?.mostVisitedCompanies?.collection ?? [];
  const simpleCompanyCards = useMemo(
    // @ts-expect-error ignore null errors from graphql
    () => createSimpleCompanies(mostVisitedCompanies),
    [mostVisitedCompanies]
  );

  return (
    <SectionContainer
      title="CP_MOST_VISITED_COMPANIES_TITLE"
      subtitle="CP_MOST_VISITED_COMPANIES_SUBLINE"
      linkUri={ROUTES.mostVisitedCompanies}
    >
      {loading ? (
        <SimpleCompanyCardGrid.Skeleton amountOfCards={LIMIT} />
      ) : (
        <SimpleCompanyCardGrid items={simpleCompanyCards} />
      )}
    </SectionContainer>
  );
};
